import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { FaSignInAlt, FaSignOutAlt } from 'react-icons/fa';
import { ImProfile } from "react-icons/im";
import { AiOutlineMenu } from 'react-icons/ai';
import {Link, useNavigate} from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';
import { PiArrowFatLineRight } from "react-icons/pi";
import MatchPlayRulesModal from './MatchPlayRulesModal';

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [managementMenuOpen, setManagementMenuOpen] = useState(false);
  const [statsMenuOpen, setStatsMenuOpen] = useState(false);
  const [rulesMenuOpen, setRulesMenuOpen] = useState(false);
  const [matchPlayRulesOpen, setMatchPlayRulesOpen] = useState(false);
  const [helpTopic, setHelpTopic] = useState('matchPlayRules');

  const { isAuthenticated, setAuth, auth } = useAuth();
  const navigate = useNavigate();
  const isAdminUser = Boolean(auth?.user?.isAdmin);

  const displayName = auth?.user?.name || [auth?.user?.firstname, auth?.user?.surename || auth?.user?.surname].filter(Boolean).join(' ') || auth?.user?.email || 'Käyttäjä';

  const handleNav = () => {
    setNav(!nav);
    setProfileMenuOpen(false);
    setManagementMenuOpen(false);
    setStatsMenuOpen(false);
    setRulesMenuOpen(false);
  };

  const handleOpenHelpTopic = (topic) => {
    setHelpTopic(topic);
    setMatchPlayRulesOpen(true);
    setNav(false);
    setProfileMenuOpen(false);
    setManagementMenuOpen(false);
    setStatsMenuOpen(false);
    setRulesMenuOpen(false);
  };

  const handleLogout = () => {
      console.log("Navbar - handleLogout");
      setProfileMenuOpen(false);
      setManagementMenuOpen(false);
      setStatsMenuOpen(false);
      setRulesMenuOpen(false);
      setNav(false);
      setAuth({});
      navigate("/");
  };

  useEffect(() => {
    if (!nav) {
      return undefined;
    }

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [nav]);

  const mobileMenu = nav && typeof document !== 'undefined'
    ? createPortal(
      <div className='fixed inset-0 z-[999] md:hidden'>
        <button
          type='button'
          aria-label='Sulje valikko'
          onClick={() => setNav(false)}
          className='absolute inset-0 bg-slate-950/70 backdrop-blur-sm'
        />
        <ul className='absolute right-0 top-0 h-full max-h-screen w-72 overflow-y-auto overflow-x-hidden border-l border-white/10 bg-slate-950 px-4 py-6 shadow-2xl shadow-slate-950/80'>
          <span
            onClick={() => setNav(false)}
            className="absolute right-4 top-4 flex cursor-pointer flex-row text-lg text-slate-200 transition hover:text-cyan-300"
          >
            Sulje <PiArrowFatLineRight className="ml-2 mt-1.5" />
          </span>

          <div className='mt-16 w-full text-center leading-tight'>
            <h1 className='text-sm font-semibold uppercase tracking-[0.32em] text-yellow-300'>Disc Golf</h1>
            <h1 className='mt-1 text-2xl font-black text-white'>Reikäpeli Cup</h1>
          </div>
          <h1 className='w-full text-center text-sm font-semibold uppercase tracking-[0.25em] text-cyan-300'>Valikko</h1>

          <li className='my-4 border-b border-white/10'></li>

          {!isAuthenticated() && (
            <>
              <li className='p-2 border-b border-white/10'>
                <Link to='/login' onClick={handleNav}
                  className='block rounded-xl px-3 py-2 text-sm font-medium text-slate-100 transition hover:bg-white/10'>
                  <FaSignInAlt className='inline mr-1' />Kirjaudu
                </Link>
              </li>

            </>
          )}

          <li className='p-2 border-b border-white/10'>
            <Link onClick={handleNav} to='/kisat'
              className='block rounded-xl px-3 py-2 text-sm font-medium text-slate-100 transition hover:bg-white/10'>
              Kisat
            </Link>
          </li>

          {isAuthenticated() && (
            <li className='p-2 border-b border-white/10'>
              <Link onClick={handleNav} to='/omat-pelit'
                className='block rounded-xl px-3 py-2 text-sm font-medium text-slate-100 transition hover:bg-white/10'>
                Omat kisat
              </Link>
            </li>
          )}

          <li className='p-2 border-b border-white/10'>
            <p className='px-3 py-2 text-sm font-semibold uppercase tracking-[0.2em] text-cyan-300'>Tilastot</p>
            <Link onClick={handleNav} to='/tilastot'
              className='mt-1 block rounded-xl px-3 py-2 pl-6 text-sm font-medium text-slate-100 transition hover:bg-white/10'>
              Pelaajat
            </Link>
            <Link onClick={handleNav} to='/radat'
              className='block rounded-xl px-3 py-2 pl-6 text-sm font-medium text-slate-100 transition hover:bg-white/10'>
              Radat
            </Link>
          </li>

          <li className='p-2 border-b border-white/10'>
            <Link onClick={handleNav} to='/jarjestajat'
              className='block rounded-xl px-3 py-2 text-sm font-medium text-slate-100 transition hover:bg-white/10'>
              Järjestäjät
            </Link>
          </li>

          <li className='px-2 pt-4 text-xs font-semibold uppercase tracking-[0.25em] text-cyan-300'>Ohjeet ja säännöt</li>
          <li className='p-2 border-b border-white/10'>
            <button
              type='button'
              onClick={() => handleOpenHelpTopic('competitionGuidelines')}
              className='block w-full rounded-xl px-3 py-2 text-left text-sm font-medium text-slate-100 transition hover:bg-white/10'
            >
              Kilpailun yleiset ohjeet
            </button>
          </li>
          <li className='p-2 border-b border-white/10'>
            <button
              type='button'
              onClick={() => handleOpenHelpTopic('paymentAndCancellation')}
              className='block w-full rounded-xl px-3 py-2 text-left text-sm font-medium text-slate-100 transition hover:bg-white/10'
            >
              Maksu- ja peruutusehdot
            </button>
          </li>
          <li className='p-2 border-b border-white/10'>
            <button
              type='button'
              onClick={() => handleOpenHelpTopic('scoringInstructions')}
              className='block w-full rounded-xl px-3 py-2 text-left text-sm font-medium text-slate-100 transition hover:bg-white/10'
            >
              Kirjaamisohjeet
            </button>
          </li>
          <li className='p-2 border-b border-white/10'>
            <button
              type='button'
              onClick={() => handleOpenHelpTopic('matchPlayRules')}
              className='block w-full rounded-xl px-3 py-2 text-left text-sm font-medium text-slate-100 transition hover:bg-white/10'
            >
              Reikäpelin säännöt
            </button>
          </li>
          <li className='p-2 border-b border-white/10'>
            <Link
              to='/tietosuojaseloste'
              onClick={handleNav}
              className='block w-full rounded-xl px-3 py-2 text-left text-sm font-medium text-slate-100 transition hover:bg-white/10'
            >
              Tietosuojaseloste
            </Link>
          </li>

          {isAdminUser && (
            <>
              <li className='px-2 pt-4 text-xs font-semibold uppercase tracking-[0.25em] text-cyan-300'>Hallinto</li>
              <li className='p-2 border-b border-white/10'>
                <Link onClick={handleNav} to='/jarjestajat'
                  className='block rounded-xl px-3 py-2 text-sm font-medium text-slate-100 transition hover:bg-white/10'>
                  Järjestäjien hallinta
                </Link>
              </li>
              <li className='p-2 border-b border-white/10'>
                <Link onClick={handleNav} to='/audit-logs'
                  className='block rounded-xl px-3 py-2 text-sm font-medium text-slate-100 transition hover:bg-white/10'>
                  Audit logs
                </Link>
              </li>
            </>
          )}

          {isAuthenticated() && (
            <>
              <li className='p-2 border-b border-white/10'>
                <Link to='/profiili'
                  className='block rounded-xl px-3 py-2 text-sm font-medium text-slate-100 transition hover:bg-white/10'>
                  <ImProfile className='inline mr-1' />Oma profiili
                </Link>
              </li>

              <li className='p-2 border-b border-white/10'>
                <button onClick={handleLogout}
                  className='w-full rounded-xl px-3 py-2 text-left text-sm text-rose-100 transition hover:bg-rose-500/10'>
                  <FaSignOutAlt className='inline mr-1' /> Kirjaudu ulos
                </button>
              </li>
            </>
          )}
        </ul>
      </div>,
      document.body
    )
    : null;

  return (
    <div className='fixed top-0 left-0 z-40 w-full border-b border-white/10 bg-slate-950/85 backdrop-blur-md shadow-2xl shadow-slate-950/40'>
    <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 text-sm font-medium text-slate-100">
        <div className="flex items-center gap-3">
          <Link to='/' className="flex items-center gap-3 rounded-full border border-cyan-400/30 bg-white/5 px-3 py-1.5 text-cyan-200 transition hover:border-cyan-300/60 hover:bg-white/10">
            <img
              src={`${process.env.PUBLIC_URL}/48.png`}
              alt="DGRC logo"
              className="h-8 w-8 rounded-full object-cover"
            />
            <span className="flex flex-col text-left leading-tight">
              <span className="text-[10px] font-semibold uppercase tracking-[0.32em] text-yellow-300">Disc Golf</span>
              <span className="text-sm font-black text-white">Event Platform</span>
            </span>
          </Link>

          <ul className='hidden md:flex items-center gap-1 rounded-full border border-white/10 bg-white/5 px-2 py-1'>
            <li><Link to='/kisat' className='rounded-full px-3 py-2 text-slate-200 transition hover:bg-white/10 hover:text-white'>Kisat</Link></li>
            {isAuthenticated() && <li><Link to='/omat-pelit' className='rounded-full px-3 py-2 text-slate-200 transition hover:bg-white/10 hover:text-white'>Omat kisat</Link></li>}
            <li className='relative'>
              <button
                type='button'
                onClick={() => {
                  setStatsMenuOpen((prev) => !prev);
                  setRulesMenuOpen(false);
                  setManagementMenuOpen(false);
                  setProfileMenuOpen(false);
                }}
                className='rounded-full px-3 py-2 text-slate-200 transition hover:bg-white/10 hover:text-white'
              >
                Tilastot
              </button>

              {statsMenuOpen && (
                <div className='absolute left-0 mt-3 w-44 overflow-hidden rounded-2xl border border-white/10 bg-slate-900/95 shadow-2xl shadow-slate-950/60 backdrop-blur'>
                  <div className='p-2'>
                    <Link
                      to='/tilastot'
                      onClick={() => setStatsMenuOpen(false)}
                      className='mb-1 block rounded-xl px-3 py-2 text-sm text-slate-100 transition hover:bg-white/10'
                    >
                      Pelaajat
                    </Link>
                    <Link
                      to='/radat'
                      onClick={() => setStatsMenuOpen(false)}
                      className='block rounded-xl px-3 py-2 text-sm text-slate-100 transition hover:bg-white/10'
                    >
                      Radat
                    </Link>
                  </div>
                </div>
              )}
            </li>
            <li><Link to='/jarjestajat' className='rounded-full px-3 py-2 text-slate-200 transition hover:bg-white/10 hover:text-white'>Järjestäjät</Link></li>
            <li className='relative'>
              <button
                type='button'
                onClick={() => {
                  setRulesMenuOpen((prev) => !prev);
                  setStatsMenuOpen(false);
                  setManagementMenuOpen(false);
                  setProfileMenuOpen(false);
                }}
                className='rounded-full px-3 py-2 text-slate-200 transition hover:bg-white/10 hover:text-white'
              >
                Ohjeet ja säännöt
              </button>

              {rulesMenuOpen && (
                <div className='absolute left-0 mt-3 w-56 overflow-hidden rounded-2xl border border-white/10 bg-slate-900/95 shadow-2xl shadow-slate-950/60 backdrop-blur'>
                  <div className='p-2'>
                    <button
                      type='button'
                      onClick={() => handleOpenHelpTopic('competitionGuidelines')}
                      className='mb-1 block w-full rounded-xl px-3 py-2 text-left text-sm text-slate-100 transition hover:bg-white/10'
                    >
                      Kilpailun yleiset ohjeet
                    </button>
                    <button
                      type='button'
                      onClick={() => handleOpenHelpTopic('paymentAndCancellation')}
                      className='mb-1 block w-full rounded-xl px-3 py-2 text-left text-sm text-slate-100 transition hover:bg-white/10'
                    >
                      Maksu- ja peruutusehdot
                    </button>
                    <button
                      type='button'
                      onClick={() => handleOpenHelpTopic('scoringInstructions')}
                      className='mb-1 block w-full rounded-xl px-3 py-2 text-left text-sm text-slate-100 transition hover:bg-white/10'
                    >
                      Kirjaamisohjeet
                    </button>
                    <button
                      type='button'
                      onClick={() => handleOpenHelpTopic('matchPlayRules')}
                      className='block w-full rounded-xl px-3 py-2 text-left text-sm text-slate-100 transition hover:bg-white/10'
                    >
                      Reikäpelin säännöt
                    </button>
                    <Link
                      to='/tietosuojaseloste'
                      onClick={() => setRulesMenuOpen(false)}
                      className='mt-1 block w-full rounded-xl px-3 py-2 text-left text-sm text-slate-100 transition hover:bg-white/10'
                    >
                      Tietosuojaseloste
                    </Link>
                  </div>
                </div>
              )}
            </li>
            {isAdminUser && (
              <li className='relative'>
                <button
                  type='button'
                  onClick={() => {
                    setManagementMenuOpen((prev) => !prev);
                    setStatsMenuOpen(false);
                    setProfileMenuOpen(false);
                    setRulesMenuOpen(false);
                  }}
                  className='rounded-full px-3 py-2 text-slate-200 transition hover:bg-white/10 hover:text-white'
                >
                  Hallinto
                </button>

                {managementMenuOpen && (
                  <div className='absolute left-0 mt-3 w-52 overflow-hidden rounded-2xl border border-white/10 bg-slate-900/95 shadow-2xl shadow-slate-950/60 backdrop-blur'>
                    <div className='p-2'>
                      <Link
                        to='/jarjestajat'
                        onClick={() => setManagementMenuOpen(false)}
                        className='block rounded-xl px-3 py-2 text-sm text-slate-100 transition hover:bg-white/10'
                      >
                        Järjestäjien hallinta
                      </Link>
                      <Link
                        to='/audit-logs'
                        onClick={() => setManagementMenuOpen(false)}
                        className='block rounded-xl px-3 py-2 text-sm text-slate-100 transition hover:bg-white/10'
                      >
                        Audit logs
                      </Link>
                    </div>
                  </div>
                )}
              </li>
            )}
          </ul>
        </div>

        <div className='hidden md:flex items-center gap-2'>
      <ul className='hidden md:flex items-center gap-2'>
            
                                
                {!isAuthenticated() && (
                <>
                  <li>
                    <Link
                      to='/login'
                      title='Kirjaudu'
                      aria-label='Kirjaudu'
                      className='inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-slate-100 transition hover:bg-white/10 hover:text-cyan-300'
                    >
                      <FaSignInAlt />
                    </Link>
                  </li>
                </>
              )}          
               
               {isAuthenticated() && (
                <>
                  <li className='relative'>
                    <button
                      onClick={() => setProfileMenuOpen((prev) => !prev)}
                      title='Profiili'
                      aria-label='Avaa profiilivalikko'
                      className='group relative inline-flex h-10 w-10 items-center justify-center rounded-full border border-cyan-400/30 bg-cyan-400/10 text-cyan-100 transition hover:bg-cyan-400/20'
                    >
                      <ImProfile className='text-lg' />
                      <span className='pointer-events-none absolute -bottom-10 left-1/2 hidden -translate-x-1/2 rounded-md bg-slate-900 px-2 py-1 text-xs text-white shadow-lg group-hover:block'>
                        Profiili
                      </span>
                    </button>

                    {profileMenuOpen && (
                      <div className='absolute right-0 mt-3 w-64 overflow-hidden rounded-2xl border border-white/10 bg-slate-900/95 shadow-2xl shadow-slate-950/60 backdrop-blur'>
                        <div className='border-b border-white/10 px-4 py-3'>
                          <p className='text-sm font-bold text-white'>{displayName}</p>
                          <p className='mt-1 text-xs text-slate-300'>{auth?.user?.email || 'Kirjautunut käyttäjä'}</p>
                        </div>
                        <div className='p-2'>
                          <Link
                            to='/profiili'
                            onClick={() => setProfileMenuOpen(false)}
                            className='mb-1 block rounded-xl px-3 py-2 text-sm text-slate-100 transition hover:bg-white/10'
                          >
                            <ImProfile className='mr-2 inline' /> Oma profiili
                          </Link>
                          <button
                            onClick={handleLogout}
                            className='block w-full rounded-xl px-3 py-2 text-left text-sm text-rose-100 transition hover:bg-rose-500/10'
                          >
                            <FaSignOutAlt className='mr-2 inline' /> Kirjaudu ulos
                          </button>
                        </div>
                      </div>
                    )}
                  </li>
                </>
              )}     
      </ul>
      </div>
      <div onClick={handleNav} className='md:hidden rounded-full border border-white/10 bg-white/5 p-2 text-slate-100 transition hover:bg-white/10'>
          <AiOutlineMenu size={20}/>
      </div>
    </div>
    {mobileMenu}
    <MatchPlayRulesModal isOpen={matchPlayRulesOpen} onClose={() => setMatchPlayRulesOpen(false)} topic={helpTopic} />
    </div>
  );
};

export default Navbar;